import { gql } from "@apollo/client";
import moment from "moment";

const GET_DOCUMENTOS_VISITAS_MEDICO = gql`
    query GetVisitasMedico($idEvaluacion: Int!) {
        visitasMedico(idEvaluacion: $idEvaluacion) {
            success,
            error,
            valorEsperado {
                idVisita,
                tipoProfesional,
                profesional,
                fechaMostrar
            }
        }
    }
`;

export default GET_DOCUMENTOS_VISITAS_MEDICO;

export const adaptDocumentoVisitaMedico = (documento) => {
  return {
    idVisita: documento?.idVisita,
    tipoProfesional: documento?.tipoProfesional,
    profesional: documento?.profesional,
    fechaVisita: documento?.fechaMostrar
  };
};

export const adaptDocumentosVisitasMedicoArray = (documentos) => {
  return structuredClone(documentos)?.
  map((documento) => adaptDocumentoVisitaMedico(documento));
};